import LocalStorage from './LocalStorage'

class LocalStorageProvider {
  static storage

  static initialize(storageKey) {
    LocalStorageProvider.storage = new LocalStorage(storageKey)
  }

  static getStorage() {
    if (!LocalStorageProvider.storage) {
      throw new Error('LocalStorageProvider is not initialized')
    }

    return LocalStorageProvider.storage
  }
}

export default LocalStorageProvider
